import { render, staticRenderFns } from "./ReviewBlockList.vue?vue&type=template&id=34680924&scoped=true"
import script from "./ReviewBlockList.vue?vue&type=script&lang=js"
export * from "./ReviewBlockList.vue?vue&type=script&lang=js"
import style0 from "./ReviewBlockList.vue?vue&type=style&index=0&id=34680924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34680924",
  null
  
)

export default component.exports